type Period = {
  startAt?: string,
  processStart: string,
  processEnd: string,
};

const parseDateTime = (value: string): number | null => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/.exec(value || '');
  if (!match) return null;

  const [, day, month, year, hour, minute] = match;
  const date = new Date(+year, +month - 1, +day, +hour, +minute);
  const valid = date.getFullYear() === +year
    && date.getMonth() === +month - 1
    && date.getDate() === +day
    && date.getHours() === +hour
    && date.getMinutes() === +minute;

  return valid ? date.getTime() : null;
};

// O prazo final não é mais digitado (é a data final do processo), então só o Início
// precisa ser validado contra o intervalo do processo.
export const validateConvocationStart = ({ startAt, processStart, processEnd }: Period): string => {
  const startLimit = parseDateTime(processStart);
  const endLimit = parseDateTime(processEnd);
  const start = parseDateTime(startAt || '');

  if (start === null) return 'Informe uma data de Início válida.';
  if (startLimit === null || endLimit === null) return 'Não foi possível validar o período do processo.';
  if (start < startLimit || start > endLimit) {
    return `A data Início deve estar entre ${processStart} e ${processEnd}.`;
  }

  return '';
};
